import React from 'react';
import { CheckCircle2, Shield, Award } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
export type VerificationLevel = 'verified' | 'community' | 'certified';
interface VerificationBadgeProps {
  level: VerificationLevel;
  className?: string;
  showLabel?: boolean;
}
export function VerificationBadge({
  level,
  className,
  showLabel = true
}: VerificationBadgeProps) {
  const config = {
    verified: {
      color: 'text-brand-success bg-brand-success/10',
      icon: CheckCircle2,
      label: 'Verified'
    },
    community: {
      color: 'text-brand-secondary bg-brand-secondary/10',
      icon: Shield,
      label: 'Community Verified'
    },
    certified: {
      color: 'text-brand-accent bg-brand-accent/10',
      icon: Award,
      label: 'Training Certified'
    }
  };
  const {
    color,
    icon: Icon,
    label
  } = config[level];
  return <div className={twMerge('inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold', color, className)} data-id="element-74">
      <Icon className="w-3.5 h-3.5 mr-1" data-id="element-75" />
      {showLabel && <span data-id="element-76">{label}</span>}
    </div>;
}